var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{class:{ 
    big: _vm.big,
    correct: _vm.color === 'correct', 
    partial: _vm.color === 'partial', 
    incorrect: _vm.color === 'incorrect',
    'color-blind': _vm.colorBlindMode,
},attrs:{"id":"key"},on:{"click":_vm.handleClick}},[_vm._v(" "+_vm._s(_vm.keyContent)+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }